export const AddTransactionModalMutableConfig = {
    validate: false,
};
